import type { ApiConfig } from '../declare'

const apis: ApiConfig[] = [
  {
    name: 'getTreePageConfigInfo',
    method: 'POST',
    path: '/PF/PageTree/GetTreePageConfigInfo',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '获取树表单配置信息'
  },
]

export default apis